<div class="container mt-6">
  <table
    mat-table
    [dataSource]="dataSource"
    data-automation="multi-load-profile-table"
  >
    <ng-container
      *ngFor="let column of displayedColumns"
      [matColumnDef]="column"
    >
      <th mat-header-cell *matHeaderCellDef>
        {{ columns.get(column) | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let stat"
        [ngClass]="{ 'row-label': column === 'rowLabel' }"
      >
        <ng-container *ngIf="column === 'rowLabel'; else otherColumns">
          <span data-automation="multi-load-profile-table-row-label">
            {{ stat['rowLabel'] | translate }}
          </span>
        </ng-container>
        <ng-template #otherColumns>
          <span>{{ stat[column] | number: '1.0-0' || '-' }}</span>
        </ng-template>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let stat; columns: displayedColumns"></tr>
  </table>
</div>
